<nb-card>
  <nb-card-header
    >{{ header }}
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <form [formGroup]="qnaForm">
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Tiêu đề câu hỏi</h6>
          <p class="text-hint">Ngắn gọn, rõ ràng nêu lên vấn đề</p>
        </div>

        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="qna.title"
        />
      </div>
      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">Mô tả</h6>
          <p class="text-hint">
            Ngắn gọn. Xảy ra ở đâu? Ảnh hưởng như thế nào?
          </p>
        </div>

        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="qna.description"
        ></textarea>
      </div>

      <div class="form-group">
        <div class="label">
          <h6 class="text-primary">
            Nội dung chi tiết
            <nb-select
              outline
              shape="round"
              size="small"
              status="info"
              formControlName="sourceType"
              [(ngModel)]="qna.sourceType"
            >
              <nb-option value="document">Tài liệu</nb-option>
              <nb-option value="video">Video</nb-option>
              <nb-option value="images">Hình ảnh</nb-option>
            </nb-select>
          </h6>
        </div>

        <div *ngIf="qna.sourceType == 'video'" class="form-group">
          <ngx-view-video [url]="qna.videoUrl"></ngx-view-video>
          <div class="form-group">
            <label class="label">Đường dẫn URL</label>
            <input
              nbInput
              fullWidth
              formControlName="url"
              placeholder="Nhập liên kết"
              class="form-control"
              [(ngModel)]="qna.videoUrl"
            />
          </div>
        </div>

        <div *ngIf="qna.sourceType == 'images'">
          <nb-card>
            <nb-card-header>
              <button
                nbButton
                outline
                fullWidth
                status="info"
                size="tiny"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="openGallery()"
              >
                <nb-icon icon="image-outline"></nb-icon>
                Chọn hình ảnh
              </button>
            </nb-card-header>
            <nb-card-body class="container">
              <div class="row">
                <div
                  class="column"
                  *ngFor="let item of imagesUrl; let i = index"
                >
                  <button
                    type="submit"
                    nbButton
                    outline
                    fullWidth
                    status="danger"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="deleteImage(item)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                  <img [src]="item" style="width: 100%" />
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <ngx-editor-document
          *ngIf="qna.sourceType == 'document'"
          formControlName="content"
          [(ngModel)]="qna.content"
        ></ngx-editor-document>
      </div>

      <div class="form-group">
        <label class="label">Nhập phân loại ( Tag)</label>
        <nb-tag-list (tagRemove)="onTagRemove($event)">
          <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
          <input type="text" nbTagInput (tagAdd)="onTagAdd($event)" fullWidth />
        </nb-tag-list>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <nb-select
      hero
      size="small"
      [status]="status == '1' ? 'success' : status == '0' ? 'info' : 'warning'"
      placeholder="Chọn trạng thái"
      [(ngModel)]="status"
    >
      <nb-option value="1">Đã giải đáp</nb-option>
      <nb-option value="0">Tìm câu trả lời</nb-option>
      <nb-option value="-1">Khóa trả lời</nb-option>
    </nb-select>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !qnaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
